import { NotificationTemplateProps } from '.';
import { NotificationSeverity } from '../constants';

const template: NotificationTemplateProps = {
  ariaLabel: 'Points successfully removed',
  message: 'Points successfully removed',
  severity: NotificationSeverity.SUCCESS,
};

export default template;
